<template>
  <main class="cart">
    <!-- <div id="smart-button-container">
      <div style="text-align: center;">
        <div style="margin-bottom: 1.25rem;">
          <p>sfdsfd df fds gfsd gds gsd gsdf</p>
          <select id="item-options">
            <option value price>- USD</option>
          </select>
          <select style="visibility: hidden" id="quantitySelect"></select>
        </div>
        <div id="paypal-button-container"></div>
      </div>
    </div>   -->

    <transition name="cartfade">
      <div class="configurator" v-if="editing">
        <Artconfig configMode="true" @editDone="editDone"/>
      </div>
    </transition>

    <transition name="cartfade">
    <div class="preview">
      <div class="aspect-ratio-box" ref="aspectRatioBox" :class="previewType">
        <div class="frame" ref="frame" :class="cartFrameStyle ? [cartFrameStyle.frame.id, cartFrameStyle.color, cartFrameStyle.mat] : ''">
          <div v-for="(item, index) in cartFrameModel" 
            class="letter"
            :key="item + index"
            :style="{backgroundImage: `url('${thumbnailsBlobRoot + item}.jpg')`}"      
          >        
          </div>          
        </div>
        <div v-if="cartFrameStyle" class="width"><span>{{physicalSize.width}}cm</span></div>
        <div v-if="cartFrameStyle" class="height"><span>{{physicalSize.height}}cm</span></div>
        <div class="brightness-adjustment"></div>
      </div>
      <div class="thumbnails">
        <div v-for="type in previewTypes"
            class="thumbnail"
            :previewType = "type"
            :class="{ [`${type}`]: true, selected: type == previewType}"
            :key="type"
            @click="previewType = type; scalePreviews();"
        >        
          <div class="frame" :class="cartFrameStyle ? [cartFrameStyle.frame.id, cartFrameStyle.color, cartFrameStyle.mat] : ''">
            <div v-for="(item, index) in cartFrameModel" 
                class="letter"
                :key="item + index"
                :style="{backgroundImage: `url('${thumbnailsBlobRoot + item}.jpg')`}"      
              >        
            </div>
          </div>
          <div v-if="type == 'pureTn'" class="sizing"></div>
        </div>
<!-- 
        <div class="white"></div>
        <div class="green"></div>
        <div class="pure">abcdefgh</div> -->
      </div>
    </div>  
    </transition>

    <transition name="cartfade">
    <div class="summary" ref="summary" v-show="!editing">      
      <div class="buttons">
        <transition name="cartfade">
          <div v-if="!paymentConfirmed && !checkout">
            <a :class="{emptyCartFontSize: cartIsEmpty}" @click="configure">configure</a> 
            <template v-if="!cartIsEmpty"> | <a @click="remove">remove</a></template>
          </div> 
        </transition>
      </div>      
      <div class="breakdown">
        <template v-if="!cartIsEmpty">
        {{cartFrameModel.length}} letters with frame <span class="price">{{netPrice/*.toFixed(1)*/}} €</span>
        <br>
        tax <span class="price">{{Math.round((tax + shippingTax)*100/*.toFixed(1)*/)/100}} €</span>        
        <br>
        {{shippingCountry.code != 'PICKUP' ? 'shipping to' : ''}} <span class="shipTo" :class="{disabled: checkout || paymentConfirmed}" ref="countrySelector" @click="toggleCountrySelector">{{shippingCountry.name}} <span :class="{triangleUp: countrySelectorOpen}">&#9660;</span></span> <span class="price">{{shippingNetPrice/*.toFixed(1)*/}} €</span>
        <transition name="cartfade">
        <div class="countries" v-if="countrySelectorOpen">
          <div v-for="country in shippingCountries"    
            :key="country.code"
            @click="setShippingCountry(country); countrySelectorOpen = false;"
          >  
          {{country.name}}
          </div>
        </div>
        </transition>
        <hr>
        <span class="total">{{Math.round((price + shippingCountry.price)*100/*.toFixed(2)*/)/100}} €</span>
        </template>
        <template v-else>
           Your cart is empty, click configure to play around and create something awesome!
        </template>
      </div>      
      <button v-if="paymentConfirmed" class="payment-confirmed">Payment Successful!</button>
      <button v-else-if="checkout" @click="cancelCheckout()" :disabled="loader || paymentloader">back to cart</button>   
      <button v-else-if="!cartIsEmpty" @click="initiateCheckout()" disabled>CHECKOUT</button>     
    </div>
    </transition>    
    
    <div id="checkoutcontainer" ref="checkout" :class="{checkoutInProgress: checkout}">
      
      <!-- <div class="termsoverlay" :class="{accepted: termsAccepted}">        
      </div> -->      
      <div class="loader" v-if="loader"></div>
      <div class="paymentoverlay" v-if="paymentloader"></div>
      <!-- <div class="paymentloader" v-if="paymentloader"></div> -->
      <!-- <div id="shipping-element" ref="stripeShipping"></div> -->
      <!-- eslint-disable-next-line -->
      <ValidationObserver v-slot="{ invalid }" tag="div" ref="billingObserver" v-if="checkout">    
        <h2>Billing details</h2>  
          <ValidationProvider name="name" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
            <input v-model.trim="billingDetails.name" id="name" type="text" :class="{notEmpty: billingDetails.name, hasError: errors[0]}" novalidate placeholder="First and last name" autocomplete="billing name" :disabled="loader">   
            <label for="name">full name</label>         
            <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
          </ValidationProvider>
          <!-- <div class="inputgrid">
            <ValidationProvider name="first name" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
              <input v-model.trim="billingDetails.firstname" id="name" type="text" :class="{notEmpty: billingDetails.firstname, hasError: errors[0]}" novalidate placeholder="Given name" autocomplete="billing given-name" :disabled="loader">   
              <label for="name">first name</label>         
              <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider name="last name" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
              <input v-model.trim="billingDetails.lastname" id="name" type="text" :class="{notEmpty: billingDetails.lastname, hasError: errors[0]}" novalidate placeholder="Family name" autocomplete="billing family-name" :disabled="loader">   
              <label for="name">last name</label>         
              <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->

          <ValidationProvider name="email" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
            <input v-model.trim="billingDetails.email" id="email" type="email" :class="{notEmpty: billingDetails.email, hasError: errors[0]}" novalidate autocomplete="email" :disabled="loader">   
            <label for="email">email</label>         
            <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
          </ValidationProvider>

          <!-- <ValidationProvider name="country" rules="required" tag="div" class="inputrow" v-slot="{ errors }">             -->
            <div class="inputrow">
            <select v-model.trim="billingDetails.address.country" id="country" type="text" :class="{notEmpty: billingDetails.address.country}" novalidate placeholder="country" autocomplete="billing country" :disabled="loader" @change="checkShippingCountry($event)">
              <option disabled value="">Please select one</option>
              <option v-for="(value, propertyName) in billingCountries" :key="value" v-bind:value="propertyName">{{value}}</option>
            </select>   
            <label class="floated" for="country">country</label> 
            <div class="select-icon"><svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" focusable="false" role="presentation" style="width: 0.8em; height: 0.8em;"><path d="M10.193 3.97a.75.75 0 0 1 1.062 1.062L6.53 9.756a.75.75 0 0 1-1.06 0L.745 5.032A.75.75 0 0 1 1.807 3.97L6 8.163l4.193-4.193z" fill="#a0a0a0" fill-rule="evenodd"></path></svg></div>        
            <!-- <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span> -->
            <span class="errormessage"></span>
          <!-- </ValidationProvider> -->
          </div>

          <div class="inputgrid">
          <ValidationProvider name="city" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
            <input v-model.trim="billingDetails.address.city" id="city" type="text" :class="{notEmpty: billingDetails.address.city, hasError: errors[0]}" novalidate autocomplete="billing address-level2" :disabled="loader">    
            <label for="city">city</label>        
            <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider name="postal code" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
            <input v-model.trim="billingDetails.address.postal_code" id="postalCode" type="text" :class="{notEmpty: billingDetails.address.postal_code, hasError: errors[0]}" novalidate placeholder="postal code" autocomplete="billing postal-code" :disabled="loader">          
            <label for="postalCode">postal code</label>  
            <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>

          <ValidationProvider name="address" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
            <input v-model.trim="billingDetails.address.line1" id="address" type="text" :class="{notEmpty: billingDetails.address.line1, hasError: errors[0]}" novalidate placeholder="Full street address" autocomplete="billing street-address" :disabled="loader">   
            <label for="address">address</label>         
            <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
          </ValidationProvider>          
          
          <div class="shipping" v-if="shippingCountry.code != 'PICKUP'">
            <h2>Shipping info</h2>             
            <checkbox checked class="p-default p-curve p-pulse p-smooth" color="danger" v-model="sameAsBilling" :disabled="billingDetails.address.country != 'HU'" v-if="billingDetails.address.country == 'HU'">
              shipping address same as billing
            </checkbox> 
            <div v-if="!sameAsBilling">
              <ValidationProvider name="shipping name" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
                <input v-model.trim="shippingDetails.name" id="shippingName" type="text" :class="{notEmpty: shippingDetails.name, hasError: errors[0]}" novalidate placeholder="First and last name" autocomplete="shipping name" :disabled="loader">   
                <label for="shippingName">full name</label>         
                <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
              </ValidationProvider> 
              <div class="inputrow">
                <select v-model.trim="shippingDetails.address.country" id="shippingCountry" type="text" :class="{notEmpty: shippingDetails.address.country}" novalidate placeholder="country" autocomplete="shipping country" :disabled="loader">
                  <option disabled value="HU" selected>Hungary</option>                  
                </select>   
                <label class="floated" for="shippingCountry">country</label> 
                <div class="select-icon"><svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" focusable="false" role="presentation" style="width: 0.8em; height: 0.8em;"><path d="M10.193 3.97a.75.75 0 0 1 1.062 1.062L6.53 9.756a.75.75 0 0 1-1.06 0L.745 5.032A.75.75 0 0 1 1.807 3.97L6 8.163l4.193-4.193z" fill="#a0a0a0" fill-rule="evenodd"></path></svg></div>                        
              </div>   

              <div class="inputgrid">
              <ValidationProvider name="shipping city" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
                <input v-model.trim="shippingDetails.address.city" id="shippingCity" type="text" :class="{notEmpty: shippingDetails.address.city, hasError: errors[0]}" novalidate autocomplete="shipping address-level2" :disabled="loader">    
                <label for="shippingCity">city</label>        
                <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider name="postal code" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
                <input v-model.trim="shippingDetails.address.postal_code" id="shippingPostalCode" type="text" :class="{notEmpty: shippingDetails.address.postal_code, hasError: errors[0]}" novalidate placeholder="postal code" autocomplete="shipping postal-code" :disabled="loader">          
                <label for="shippingPostalCode">postal code</label>  
                <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
              </ValidationProvider>   
              </div>

              <ValidationProvider name="shipping address" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
                <input v-model.trim="shippingDetails.address.line1" id="shippingaddress" type="text" :class="{notEmpty: shippingDetails.address.line1, hasError: errors[0]}" novalidate placeholder="Full street address" autocomplete="shipping street-address" :disabled="loader">   
                <label for="shippingaddress">address</label>         
                <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
              </ValidationProvider>                     
            </div>
            <ValidationProvider name="phone" :rules="{ required: true, phone: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/ }" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">            
              <input v-model.trim="shippingDetails.phone" id="phone" type="tel" :class="{notEmpty: shippingDetails.phone, hasError: errors[0]}" novalidate placeholder="With country code" autocomplete="shipping mobile" :disabled="loader">            
              <label for="phone">phone for the courier</label>
              <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        <h2>Payment method</h2>   
      </ValidationObserver>
      
      <div id="payment-element" ref="stripePayment"></div>
      <!-- <div id="billing-element" ref="stripeBilling"></div> -->
      <div class="termscheckbox" v-if="checkout">
        <checkbox class="p-default p-curve p-pulse p-smooth" color="danger" v-model="termsAccepted" @change="checkTerms($event)">
          I accept the terms &amp; conditions:
          <!-- <span style="opacity: 0.7; font-size: 12px;">:</span> -->
        </checkbox>
        <a href="/legal" target="_blank">link</a>
      </div>
      <button v-if="checkout && !paymentConfirmed" @click="confirmStripePayment()" :disabled="!termsAccepted || paymentloader" class="confirmPayment">{{buttonText}}
        <div class="spinner" v-if="paymentloader">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </button>  
      
      <!-- <div id="payment-request-button" ref="stripecontainer"></div> 
      <div id="paypalcontainer" ref="paypalcontainer"></div>     -->
      <!-- <button @click="debugshit">Update</button>  
      <hr>
      <textarea v-model="stripestyle"></textarea>           -->
    </div>
    <div class="checkout-messages" ref="checkoutMessages" id="checkout-messages">
      <div v-if="paymentConfirmed" class="thankyou-message">
        <h2>Thank you for your purchase!</h2>
        <p>We've sent a confirmation to <i>{{orderResult.email}}</i> about your order with number: {{orderResult.id}}</p>
        <template v-if="!orderResult.name || orderResult.name == 'PICKUP'">
          <p>Every artwork is different, and crafted by hand. Once your unique piece is ready, we will reach out to you and let you know you can come pick it up at the following address: </p>
          <p class="shipping-address">1077 Budapest, Dob street 107</p>
        </template>
        <template v-else>
          <p>Every artwork is different, and crafted by hand. Once your unique piece is ready, we will send you the tracking information, and will ship to the following address: </p>
          <p class="shipping-address">{{orderResult.name}}, {{orderResult.address_1}} {{orderResult.address_2}}, {{orderResult.postal}} {{orderResult.admin_1}} {{orderResult.admin_2}}, {{orderResult.country}}</p>
        </template>
        <p>Should you have any questions regarding your order, please get in touch on the <router-link :to="{path: '/contact'}">contact</router-link> page, or by just replying to the confirmation email.</p>
        <p>We hope you will enjoy it just as much as we enjoy creating it! And would also like to thank you for your support in the name of the <router-link :to="{path: '/about', hash: '#faq'}">charities</router-link>, where <strike>10%</strike> currently 100% of our profits go, to help refugees of Ukraine.</p>
        
        <div class="social">
          <!-- <a href="https://www.facebook.com/cityphography" class="messenger" target="_blank" ></a><span>|</span> -->
          <a href="https://www.facebook.com/cityphography" target="_blank">facebook</a><span>|</span>
          <a href="https://www.instagram.com/cityphography" target="_blank">instagram</a>
          <br>
          <span class="hashtag">#cityphography</span>        
        </div>  
      </div>
      <div v-else-if="checkout" class="phonenumber-message">        
        Two-factor authentication may be required with card payments for fraud prevention due to EU regulations. 
        <!-- <br> -->
        We do not receive your card details from our payment providers.
      </div>
    </div>

    <transition name="cartfade">
      <div class="infotext" v-if="!editing">
        <span style="color: var(--color-error); font-weight:bold;">Ordering temporarily not available because of company changes. Until we are back, please get in touch for any inquiries.</span>
        <br>
        <br>
        For frequently asked questions please see the <router-link :to="{path: '/about', hash: '#faq'}">info</router-link> page.
        <br v-if="sandbox">
        <br v-if="sandbox">
        <span v-if="sandbox" style="color: var(--color-error);">[SANDBOX ENVIRONMENT]</span>
      </div>
    </transition>
    
    <Snackbar ref="snackbar" />

  </main>
</template>

<script>
//import Content from '@/components/Content.vue';
import OverlayScrollbars from 'overlayscrollbars';
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
import { mapGetters } from 'vuex';
import Artconfig from '@/components/Artconfig.vue';
import Snackbar from '@/components/Snackbar.vue';
import axios from 'axios';
import checkbox from 'pretty-checkbox-vue/check';
import {getFrameDimensions} from '@/utils.js'
import { required, email, regex } from 'vee-validate/dist/rules.umd';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

extend('email', {...email, message: "Please provide a valid email address."});
extend('required', {...required, message:'Your {_field_} is required.'});
extend("phone", {...regex, message: "Please provide a valid phone number."});

var stripe
var elements


let lightThemeStripeAppearance = {
  theme: 'flat',
  labels: 'floating',
  variables: {
    spacingUnit: '3px',
    borderRadius: '0px',
    colorBackground: '#fff',
    fontFamily: 'Averia',
    colorDanger: '#960505',
    colorLogo: 'light',
    colorLogoTab: 'light',
    colorLogoBlock: 'light',
    colorTextPlaceholder: '#a0a0a0',
    colorText: '#000'
  },            
  rules: {
    '.Input': {
      border: 'none',
      borderBottom: '1px solid #ddd',
      paddingLeft: '0px',
      paddingBottom: '2px',
      fontFamily: 'Courier New, Courier, monospace',
      backgroundColor: 'var(--colorBackground)'
    },
    '.Input:focus': {
      outline: 'none',
      boxShadow: 'none',
      borderBottom: '1px solid #000'
    },
    ".Input--invalid, .Input--invalid:focus": {
      "boxShadow": "none",
      borderBottom: '1px solid var(--colorDanger)'
    },
    '.Label': {
      textTransform: 'lowercase',
      color: '#30313d'
    },
    '.Label--resting':{
      color: '#a0a0a0'
    },
    '.Error':{
      fontSize: '12px'
    },
    ".Tab": {
      "backgroundColor": "#f6f6f6",
      "borderRadius": "3px",
      "fontFamily": "Courier New, Courier, monospace",				
      "color": "#a0a0a0"
    },
    '.Tab:hover': {
      color: 'var(--colorText)',
    },

    ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {				
      "boxShadow": "none",
      "backgroundColor": "#eee",
      "outline": "none",
      "color": "#000",
      "fontWeight":"bold"
    },
    ".Tab:focus": {
      "outline": "none",
      "boxShadow": "none"
    },
    
    ".TabIcon": {
      "fill": "#a0a0a0"
    },
    ".TabIcon:hover": {
      "fill": "#ff3c00"
    },
    ".TabIcon--selected": {
      "fill": "#000"
    },
    
    ".Block": {
      "padding": "10px 0 10px 0",				
      "outline": "none",
      "boxShadow": "none",
      backgroundColor: 'var(--colorBackground)'
    }

    // See all supported class names and selector syntax below
  }
}


let darkThemeStripeAppearance = {
  theme: 'flat',
  labels: 'floating',
  variables: {
    spacingUnit: '3px',
    borderRadius: '0px',
    colorBackground: '#272727',
    fontFamily: 'Averia',
    colorDanger: '#c94848',
    colorLogo: 'dark',
    colorLogoTab: 'dark',
    colorLogoBlock: 'dark',
    colorTextPlaceholder: '#646464',
    colorText: '#fff'
  },            
  rules: {
    '.Input': {
      border: 'none',
      borderBottom: '1px solid #646464',
      paddingLeft: '0px',
      paddingBottom: '2px',
      fontFamily: 'Courier New, Courier, monospace',
      backgroundColor: 'var(--colorBackground)'
    },
    '.Input:focus': {
      outline: 'none',
      boxShadow: 'none',
      borderBottom: '1px solid #c0c0c0'
    },
    ".Input--invalid, .Input--invalid:focus": {
      "boxShadow": "none",
      borderBottom: '1px solid var(--colorDanger)'
    },
    '.Label': {
      textTransform: 'lowercase',
      color: '#cfd2d6'
    },
    '.Label--resting':{
      color: '#898989'
    },
    '.Error':{
      fontSize: '12px'
    },
    ".Tab": {
      "backgroundColor": "#363636",
      "borderRadius": "3px",
      "fontFamily": "Courier New, Courier, monospace",				
      "color": "#646464"
    },
    '.Tab:hover': {
      color: 'var(--colorText)',
    },

    ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {				
      "boxShadow": "none",
      "backgroundColor": "#646464",
      "outline": "none",
      "color": "#cfd2d6",
      "fontWeight":"bold"
    },
    ".Tab:focus": {
      "outline": "none",
      "boxShadow": "none"
    },
    
    ".TabIcon": {
      "fill": "#a0a0a0"
    },
    ".TabIcon:hover": {
      "fill": "#ff3c00"
    },
    ".TabIcon--selected": {
      "fill": "#cfd2d6"
    },
    
    ".Block": {
      "padding": "10px 0 10px 0",				
      "outline": "none",
      "boxShadow": "none",
      backgroundColor: 'var(--colorBackground)'
    }

    // See all supported class names and selector syntax below
  }
}

export default {
  name: "StripeCart",
  components: {
    Artconfig,
    Snackbar,
    checkbox,
    ValidationObserver,
    ValidationProvider
  },  
  metaInfo() {
    return {
      title: "cart - cityphography",
      meta: [        
        { vmid: "og:title", property: "og:title", content: "cart - cityphography" },
        { vmid: "description", name: "description", content: "Your shopping cart on cityphography. We accept all major credit/debit cards and also PayPal. For shipping info please check the about page." },
        { vmid: "og:description", property: "og:description", content: "Your shopping cart on cityphography. We accept all major credit/debit cards and also PayPal. For shipping info please check the about page." }                        
      ],
    };
  },
  data: function() {
    return {
      thumbnailsBlobRoot: process.env.VUE_APP_THUMBNAILS_BLOB_ROOT,
      previewType: "whiteTn",
      previewTypes: ['whiteTn', 'greenTn', 'pureTn'],      
      checkout: false,
      termsAccepted: false,
      loader: false,
      paymentloader: false,
      paymentConfirmed: false,
      order: undefined,
      sandbox: process.env.VUE_APP_INTEGRATION_MODE != 'LIVE',
      orderResult: {
        id: '',
        email: '',
        name: '',
        address_1: '',
        address_2: '',
        admin_1: '',
        admin_2: '',
        postal: '',
        country: ''
      },
      sizeScale: 1,
      editing: false,
      shippingCountries: [
        { name: 'PICKUP in Budapest', code: 'PICKUP', price: 0.0 },
        { name: 'Hungary', code: 'HU', price: 9.9 }/*,
        { name: 'Austria', code: 'AU', price: 10 },
        { name: 'Slovakia', code: 'SK', price: 11 },
        { name: 'Romania', code: 'RO', price: 12 },        
        { name: 'Austria', code: 'A2U', price: 10 },
        { name: 'Slovakia', code: 'S3K', price: 11 },
        { name: 'Hungary', code: 'H4U', price: 9 },
        { name: 'Austria', code: 'A5U', price: 10 },
        { name: 'Slovakia', code: 'S6K', price: 11 },
        { name: 'Hungary', code: 'H7U', price: 9 },
        { name: 'Austria', code: 'A8U', price: 10 },
        { name: 'Slovakia', code: 'S9K', price: 11 },*/
      ],
      countrySelectorOpen: false,
      billingCountries: {
        "AF": "Afghanistan",
        "AL": "Albania",
        "DZ": "Algeria",
        "AS": "American Samoa",
        "AD": "Andorra",
        "AO": "Angola",
        "AI": "Anguilla",
        "AQ": "Antarctica",
        "AG": "Antigua and Barbuda",
        "AR": "Argentina",
        "AM": "Armenia",
        "AW": "Aruba",
        "AU": "Australia",
        "AT": "Austria",
        "AZ": "Azerbaijan",
        "BS": "Bahamas (the)",
        "BH": "Bahrain",
        "BD": "Bangladesh",
        "BB": "Barbados",
        "BY": "Belarus",
        "BE": "Belgium",
        "BZ": "Belize",
        "BJ": "Benin",
        "BM": "Bermuda",
        "BT": "Bhutan",
        "BO": "Bolivia (Plurinational State of)",
        "BQ": "Bonaire, Sint Eustatius and Saba",
        "BA": "Bosnia and Herzegovina",
        "BW": "Botswana",
        "BV": "Bouvet Island",
        "BR": "Brazil",
        "IO": "British Indian Ocean Territory (the)",
        "BN": "Brunei Darussalam",
        "BG": "Bulgaria",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "CV": "Cabo Verde",
        "KH": "Cambodia",
        "CM": "Cameroon",
        "CA": "Canada",
        "KY": "Cayman Islands (the)",
        "CF": "Central African Republic (the)",
        "TD": "Chad",
        "CL": "Chile",
        "CN": "China",
        "CX": "Christmas Island",
        "CC": "Cocos (Keeling) Islands (the)",
        "CO": "Colombia",
        "KM": "Comoros (the)",
        "CD": "Congo (the Democratic Republic of the)",
        "CG": "Congo (the)",
        "CK": "Cook Islands (the)",
        "CR": "Costa Rica",
        "HR": "Croatia",
        "CU": "Cuba",
        "CW": "Curaçao",
        "CY": "Cyprus",
        "CZ": "Czechia",
        "CI": "Côte d'Ivoire",
        "DK": "Denmark",
        "DJ": "Djibouti",
        "DM": "Dominica",
        "DO": "Dominican Republic (the)",
        "EC": "Ecuador",
        "EG": "Egypt",
        "SV": "El Salvador",
        "GQ": "Equatorial Guinea",
        "ER": "Eritrea",
        "EE": "Estonia",
        "SZ": "Eswatini",
        "ET": "Ethiopia",
        "FK": "Falkland Islands (the) [Malvinas]",
        "FO": "Faroe Islands (the)",
        "FJ": "Fiji",
        "FI": "Finland",
        "FR": "France",
        "GF": "French Guiana",
        "PF": "French Polynesia",
        "TF": "French Southern Territories (the)",
        "GA": "Gabon",
        "GM": "Gambia (the)",
        "GE": "Georgia",
        "DE": "Germany",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GR": "Greece",
        "GL": "Greenland",
        "GD": "Grenada",
        "GP": "Guadeloupe",
        "GU": "Guam",
        "GT": "Guatemala",
        "GG": "Guernsey",
        "GN": "Guinea",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HT": "Haiti",
        "HM": "Heard Island and McDonald Islands",
        "VA": "Holy See (the)",
        "HN": "Honduras",
        "HK": "Hong Kong",
        "HU": "Hungary",
        "IS": "Iceland",
        "IN": "India",
        "ID": "Indonesia",
        "IR": "Iran (Islamic Republic of)",
        "IQ": "Iraq",
        "IE": "Ireland",
        "IM": "Isle of Man",
        "IL": "Israel",
        "IT": "Italy",
        "JM": "Jamaica",
        "JP": "Japan",
        "JE": "Jersey",
        "JO": "Jordan",
        "KZ": "Kazakhstan",
        "KE": "Kenya",
        "KI": "Kiribati",
        "KP": "Korea (the Democratic People's Republic of)",
        "KR": "Korea (the Republic of)",
        "KW": "Kuwait",
        "KG": "Kyrgyzstan",
        "LA": "Lao People's Democratic Republic (the)",
        "LV": "Latvia",
        "LB": "Lebanon",
        "LS": "Lesotho",
        "LR": "Liberia",
        "LY": "Libya",
        "LI": "Liechtenstein",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "MO": "Macao",
        "MG": "Madagascar",
        "MW": "Malawi",
        "MY": "Malaysia",
        "MV": "Maldives",
        "ML": "Mali",
        "MT": "Malta",
        "MH": "Marshall Islands (the)",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MU": "Mauritius",
        "YT": "Mayotte",
        "MX": "Mexico",
        "FM": "Micronesia (Federated States of)",
        "MD": "Moldova (the Republic of)",
        "MC": "Monaco",
        "MN": "Mongolia",
        "ME": "Montenegro",
        "MS": "Montserrat",
        "MA": "Morocco",
        "MZ": "Mozambique",
        "MM": "Myanmar",
        "NA": "Namibia",
        "NR": "Nauru",
        "NP": "Nepal",
        "NL": "Netherlands (the)",
        "NC": "New Caledonia",
        "NZ": "New Zealand",
        "NI": "Nicaragua",
        "NE": "Niger (the)",
        "NG": "Nigeria",
        "NU": "Niue",
        "NF": "Norfolk Island",
        "MP": "Northern Mariana Islands (the)",
        "NO": "Norway",
        "OM": "Oman",
        "PK": "Pakistan",
        "PW": "Palau",
        "PS": "Palestine, State of",
        "PA": "Panama",
        "PG": "Papua New Guinea",
        "PY": "Paraguay",
        "PE": "Peru",
        "PH": "Philippines (the)",
        "PN": "Pitcairn",
        "PL": "Poland",
        "PT": "Portugal",
        "PR": "Puerto Rico",
        "QA": "Qatar",
        "MK": "Republic of North Macedonia",
        "RO": "Romania",
        "RU": "Russian Federation (the)",
        "RW": "Rwanda",
        "RE": "Réunion",
        "BL": "Saint Barthélemy",
        "SH": "Saint Helena, Ascension and Tristan da Cunha",
        "KN": "Saint Kitts and Nevis",
        "LC": "Saint Lucia",
        "MF": "Saint Martin (French part)",
        "PM": "Saint Pierre and Miquelon",
        "VC": "Saint Vincent and the Grenadines",
        "WS": "Samoa",
        "SM": "San Marino",
        "ST": "Sao Tome and Principe",
        "SA": "Saudi Arabia",
        "SN": "Senegal",
        "RS": "Serbia",
        "SC": "Seychelles",
        "SL": "Sierra Leone",
        "SG": "Singapore",
        "SX": "Sint Maarten (Dutch part)",
        "SK": "Slovakia",
        "SI": "Slovenia",
        "SB": "Solomon Islands",
        "SO": "Somalia",
        "ZA": "South Africa",
        "GS": "South Georgia and the South Sandwich Islands",
        "SS": "South Sudan",
        "ES": "Spain",
        "LK": "Sri Lanka",
        "SD": "Sudan (the)",
        "SR": "Suriname",
        "SJ": "Svalbard and Jan Mayen",
        "SE": "Sweden",
        "CH": "Switzerland",
        "SY": "Syrian Arab Republic",
        "TW": "Taiwan",
        "TJ": "Tajikistan",
        "TZ": "Tanzania, United Republic of",
        "TH": "Thailand",
        "TL": "Timor-Leste",
        "TG": "Togo",
        "TK": "Tokelau",
        "TO": "Tonga",
        "TT": "Trinidad and Tobago",
        "TN": "Tunisia",
        "TR": "Turkey",
        "TM": "Turkmenistan",
        "TC": "Turks and Caicos Islands (the)",
        "TV": "Tuvalu",
        "UG": "Uganda",
        "UA": "Ukraine",
        "AE": "United Arab Emirates (the)",
        "GB": "United Kingdom of Great Britain and Northern Ireland (the)",
        "UM": "United States Minor Outlying Islands (the)",
        "US": "United States of America (the)",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VU": "Vanuatu",
        "VE": "Venezuela (Bolivarian Republic of)",
        "VN": "Viet Nam",
        "VG": "Virgin Islands (British)",
        "VI": "Virgin Islands (U.S.)",
        "WF": "Wallis and Futuna",
        "EH": "Western Sahara",
        "YE": "Yemen",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "AX": "Åland Islands"
    },
      billingDetails: {
        address: {
          country: 'HU'
        }
      },
      shippingDetails: {
        address: {
          country: 'HU'
        }
      },
      sameAsBilling: true,

      // testing
      stripestyle: ""
    }
  },
  watch: {
    theme() {    
      elements.update({appearance: this.theme == 'dark' ? darkThemeStripeAppearance : lightThemeStripeAppearance })
    }
  },
  computed: {
    ...mapState([
      // map this.count to store.state.count
      //'count'
      'cartFrameModel',
      'cartFrameStyle',
      'pricePer',
      'shippingCountry',
      'theme'
    ]),
    ...mapGetters([  
      'cartIsEmpty',
      'price',
      'netPrice',
      'shippingNetPrice',
      'tax',
      'shippingTax'
      // ...
    ]),
    word(){
      return this.cartFrameModel.map(code => code[0]).join("").toLowerCase();
    },
    referenceId(){      
      return btoa(`${this.cartFrameModel.join("|").toLowerCase()}_${this.cartFrameStyle.frame.id}_${this.cartFrameStyle.color}_${this.cartFrameStyle.mat}`) 
    },
    longDescription(){
      return `'${this.word}' in ${this.cartFrameStyle.color} ${this.cartFrameStyle.frame.id} frame (${this.cartFrameStyle.mat})`
      // Style reference: [${this.referenceId}]
    },
    shortDescription(){
      return `'${this.word}' in ${this.cartFrameStyle.color} ${this.cartFrameStyle.frame.id} frame`
    },
    physicalSize(){
      return this.cartFrameStyle ? getFrameDimensions(this.cartFrameModel, this.cartFrameStyle.frame) : null
    },
    buttonText: function(){
      return this.paymentloader ? '' : 'CONFIRM CARD PAYMENT';
    }      
  },  
  methods: {
    debugshit(){      
      elements.update(JSON.parse(this.stripestyle))      
    },
    async confirmStripePayment(){

      this.$refs.billingObserver.validate()
      if(this.$refs.billingObserver.flags.invalid)
      {
        this.$refs.snackbar.show('Please provide valid billing and/or shipping details before continuing')
        return
      }

      //paymentLoaderTiomeout = setTimeout( () => this.paymentloader = true, 300 )
      this.paymentloader = true
      //this.billingDetails.name = `${this.billingDetails.firstname} ${this.billingDetails.lastname}`
      const {error, paymentIntent} = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        redirect: "if_required",
        confirmParams: {
          shipping: this.shippingCountry.code == 'PICKUP' 
            ? null
            : {
              phone: this.shippingDetails.phone,
              name: this.sameAsBilling ? this.billingDetails.name : this.shippingDetails.name,
              address: this.sameAsBilling ? this.billingDetails.address : this.shippingDetails.address
            },
          payment_method_data: {
            billing_details: this.billingDetails
          }
        }
      });

      if (error) {
        this.paymentloader = false
        // The payment failed -- ask your customer for a new payment method.
        if(error.type == 'validation_error' || error.type == 'card_error')
          this.$refs.snackbar.show(error.message);
        else
          this.$refs.snackbar.show('Stripe: An error occurred with your payment request, please try again or get in touch with us.');
        console.error("Stripe", error)
        this.appInsights.trackEvent({name: "Cart.Error", properties: error});
      } else {
        // The payment has succeeded.
        this.paymentloader = false
        this.stripeCheckoutSuccess(paymentIntent)
        //this.$refs.snackbar.show('Stripe: siker, TODO success handler on my side.');
      }
    },
    checkShippingCountry(){
      if(this.billingDetails.address.country != 'HU')
        this.sameAsBilling = false
    },
    checkTerms(event){
      this.appInsights.trackEvent({name: `Cart.${event ? 'TermsAccepted' : 'TermsUnchecked'}`});   
    },
    toggleCountrySelector(){
      if(!this.checkout && !this.paymentConfirmed)
        this.countrySelectorOpen = !this.countrySelectorOpen;
    },
    editDone: function(){
      this.editing = false;
      this.$store.commit('setInCartConfigFlag', false);       
      document.querySelector('.preview').classList.remove('hide')
      setTimeout(() => this.scalePreviews(), 100);
    },
    scalePreviews: function(){
      this.$refs.frame.style.transform = this.getPreviewTransform(this.previewType, this.$refs.aspectRatioBox);
      document.getElementsByClassName('thumbnail').forEach(thumbnail => {
        thumbnail.firstElementChild.style.transform = this.getPreviewTransform(thumbnail.getAttribute('previewType'), thumbnail);
      });      

      if(this.previewType == 'pureTn'){    
        setTimeout(() =>{
          let measureX = document.querySelector('.preview .pureTn .width')
          let measureY = document.querySelector('.preview .pureTn .height')

          let frameHeight = this.$refs.frame?.offsetHeight*this.sizeScale      
          let frameWidth = this.$refs.frame?.offsetWidth*this.sizeScale
          let boxWidth = this.$refs.aspectRatioBox?.offsetWidth
          let boxHeight = this.$refs.aspectRatioBox?.offsetHeight
          let bottomSpace = (boxHeight - frameHeight)/2        

          if(measureX){
            measureX.style.width = frameWidth + 'px'
            measureX.style.left = (boxWidth - frameWidth)/2 + 'px'
            measureX.style.top = bottomSpace + frameHeight + (bottomSpace * 0.3 > 16 ? bottomSpace * 0.3 : 16) + 'px'
          }
          if(measureY){
            measureY.style.width = frameHeight + 'px'
            measureY.style.left = (boxWidth - frameWidth)/4 - 7 + 'px'
            measureY.style.top = bottomSpace + frameHeight + 'px'  
          }
        }, 300)    
      }
      else{
        let measureX = document.querySelector('.preview .pureTn .width')
        let measureY = document.querySelector('.preview .pureTn .height')
        if(measureX)
          measureX.style.width = 0
        if(measureY)
          measureY.style.width = 0
      }      
    },
    getPreviewTransform: function(type, element){
      // white center: x 300 y 135
      // green center: x 290 y 110
      // pure is just regular center with padding
      
      let thumbnail = element.classList.contains('thumbnail');
      let frameWidth = this.$refs.frame.offsetWidth;
      let frameHeight = this.$refs.frame.offsetHeight;
      let aspectScale = thumbnail ? 1 : (this.$refs.aspectRatioBox.offsetWidth / 554); // this is on top of all other transforms, if width < maxwidth
      let previewScale, translateX, translateY;
      switch(type) {
        case 'whiteTn':
          translateX = (thumbnail ? 55 : 300*aspectScale) - frameWidth/2;
          translateY = (thumbnail ? 27 : 135*aspectScale) - frameHeight/2;
          previewScale = thumbnail ? (0.2*100/554) : 0.185;
          break;
        case 'greenTn':
          translateX = (thumbnail ? 55 : 290*aspectScale) - frameWidth/2;
          translateY = (thumbnail ? 23 : 110*aspectScale) - frameHeight/2;
          previewScale = thumbnail ? (0.2*100/554) : 0.23;
          break;
        default: // pure
          translateX = (thumbnail ? 50 : 554/2*aspectScale) - frameWidth/2;
          translateY = (thumbnail ? 34 : 370/2*aspectScale) - frameHeight/2;
          previewScale = element.offsetWidth / frameWidth * 0.75/aspectScale;
          if(!thumbnail)
            this.sizeScale = previewScale * aspectScale
      }           
      return `translateX(${translateX}px) translateY(${translateY}px) scale(${previewScale * aspectScale})`;
    },
    cancelCheckout: function(afterSuccessfulPayment){
      this.checkout = false;
      // this.$refs.paypalcontainer.innerHTML = '';    
      // this.prButton.destroy();  
      this.paymentElement?.destroy()
      this.termsAccepted = false

      if(this.paymentConfirmed){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        setTimeout(() => OverlayScrollbars(document.body).scroll({el: document.getElementById('checkout-messages'), margin: vw > 992 ? 0 : 60}, 500), 300);
        // if(vw > 992){          
        //   setTimeout(() => OverlayScrollbars(document.body).scroll({el: document.getElementById('checkout-messages'), margin: 0}, 500), 300);          
        // }
        // else{
        //   //document.getElementsByTagName('header')[0].classList.add("scrolled")
        //   setTimeout(() => OverlayScrollbars(document.body).scroll({el: document.getElementById('checkout-messages'), margin: 65}, 500), 300);
        //   setTimeout(() => document.getElementsByTagName('header')[0].classList.add("scrolled"), 850)
        // }
      }
      else{
        document.getElementsByTagName('header')[0].classList.remove("scrolled");   // TODO again this should be in vuex to control menu
        OverlayScrollbars(document.body).scroll({ y : 0 }, 500);
      }   
      if(!afterSuccessfulPayment)
        this.appInsights.trackEvent({name: "Cart.Cancel"});   
      this.loader = false  
    },
    stripeCheckoutSuccess(paymentIntent/*, paymentRequest*/){
      //  console.log("TEST logging stripe payments results:")
      //  console.log(paymentIntent)
      //  console.log('string magic: ' + JSON.stringify(paymentIntent))
      this.orderResult.email = this.billingDetails.email
      this.orderResult.id = paymentIntent.id.substring(3)
      if(!paymentIntent.shipping){
        // checkout success message does not need any name or shipping info
      }
      else{
        this.orderResult.name = paymentIntent.shipping.name
        this.orderResult.address_1 = paymentIntent.shipping.address.line1
        this.orderResult.address_2 = paymentIntent.shipping.address.line2
        this.orderResult.admin_1 = paymentIntent.shipping.address.city
        this.orderResult.admin_2 = paymentIntent.shipping.address.state
        this.orderResult.postal = paymentIntent.shipping.address.postal_code
        this.orderResult.country = paymentIntent.shipping.address.country
      }
      this.appInsights.trackEvent({name: "Cart.CapturedOrder", properties: paymentIntent})
      this.$refs.snackbar.show('Transaction completed, paid ' + (paymentIntent.amount/100.0).toFixed(2) + ' ' + paymentIntent.currency.toUpperCase());      
      this.paymentConfirmed = true
      this.cancelCheckout(true)
    },
    async initiateCheckout(){
      this.checkout = true
      this.loader = true

      this.appInsights.trackEvent({name: "Cart.CheckoutStart", properties: {reference: atob(this.referenceId), shipping: this.shippingCountry.code}});
      
      try {
        let stripePaymentRequest = await axios({ url: process.env.VUE_APP_API_URL + "stripe/paymentrequest", 
            data: {
              //shippingAddress: {},
              shippingCountryCode: this.shippingCountry.code,
              //shippingOption: {id: 'local-pickup'},
              referenceId: this.referenceId,
              //email: 'lofasz@lofasz.hu'
              description: this.longDescription
            }, 
            method: "POST", 
            mode: 'no-cors' })
        
        const options = {
          clientSecret: stripePaymentRequest.data.client_secret,
          // Fully customizable with appearance API.
          fonts: [
            {
              family: 'Averia',
              src: 'url(https://cityphography.com/fonts/AveriaSerif-Regular.ea879dd4.ttf)'}
          ],
          appearance: this.theme == 'dark' ? darkThemeStripeAppearance : lightThemeStripeAppearance,
          // fields: {
          //   billingDetails: 'never'
          // }
          
        };
        //console.log(options)
        // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
        elements = stripe.elements(options);
        //this.stripestyle = JSON.stringify(options)
        // elements.update(options)

        // Create and mount the Payment Element
        const paymentElement = elements.create('payment'
        , {fields: 
          {
            billingDetails: {
              name: 'never',
              address: {
                country: 'never'
              }
            } 
          }
        }
        );
        paymentElement.mount('#payment-element');
        this.paymentElement = paymentElement
        paymentElement.on('ready', () => {
          // console.log("Payment Element ready")
          // this.paymentElement.ready = true
          // if(this.shippingAddressElement.ready){
            setTimeout(() => OverlayScrollbars(document.body).scroll({ el : this.$refs.checkout, block : "begin", margin : false }, 500), 400)            
            this.loader = false
          // }
        });

        // const shippingAddressElement = elements.create("shippingAddress");
        // shippingAddressElement.mount("#shipping-element");
        // this.shippingAddressElement = shippingAddressElement
        // shippingAddressElement.on('ready', () => {
        //   console.log("Shipping Address Element ready")
        //   this.shippingAddressElement.ready = true
        //   if(this.paymentElement.ready){
        //     setTimeout(() => OverlayScrollbars(document.body).scroll({ el : this.$refs.checkout, block : "begin", margin : false }, 500), 400)
        //     this.loader = false
        //   }
        // });
        // shippingAddressElement.on('change', (event) => {
        //   // const address = event.value.address;
        //   console.log(event.value)
        // })

        // const billingAddressElement = elements.create("shippingAddress")
        // billingAddressElement.mount("#billing-element")
        // this.billingAddressElement = billingAddressElement

        //paymentElement.collapse()
        // setTimeout(() => {
        //     let shit = elements.getElement('payment');
        //     shit.collapse();
        // },3000)        

      }
      catch{
        this.$refs.snackbar.show('Ooops, something went wrong :( Please try again or get in touch with us. We logged the error and are on it.', 5000);
        this.cancelCheckout() // in case setting up the payment intent fails, or any unexpected shit
      }

      // let paymentRequest = stripe.paymentRequest({
      //   country: 'HU',
      //   currency: 'eur',
      //   total: {
      //     label: this.longDescription,
      //     amount: Math.round((this.price + this.shippingCountry.price)*100)//.toFixed(1),
      //   },
      //   requestPayerName: true,
      //   requestPayerEmail: true,
      //   requestShipping: true,
      //   //requestPayerPhone: true
      // });      
      
      // (async () => {
      //   // Check the availability of the Payment Request API first.
      //   const result = await paymentRequest.canMakePayment();
      //   if (result) {          
      //     let prButton = elements.create('paymentRequestButton', {
      //       paymentRequest: paymentRequest,
      //       style: {
      //         paymentRequestButton: {
      //           type: 'default',
      //           // One of 'default', 'book', 'buy', or 'donate'
      //           // Defaults to 'default'
      //           theme: 'dark',
      //           // One of 'dark', 'light', or 'light-outline'
      //           // Defaults to 'dark'
      //           height: '30px',
      //           // Defaults to '40px'. The width is always '100%'.
      //         },
      //       },
      //     });
      //     this.prButton = prButton
      //     prButton.mount('#payment-request-button');
      //     prButton.on('click', () => {
      //       this.loader = true
      //       this.appInsights.trackEvent({name: "Cart.PaymentRequestButton"});
      //     });
      //   } else {
      //     document.getElementById('payment-request-button').style.display = 'none';
      //   }
      // })();

      // paymentRequest.on('cancel', () => {
      //   this.loader = false
      //   this.appInsights.trackEvent({name: "Cart.PaymentCancel"});
      // });

      // paymentRequest.on('paymentmethod', async (ev) => {   
      //   //debugger     
      //   //this.appInsights.trackEvent({name: "Cart.PaymentRequest", properties: {units: JSON.stringify(ev)}});
      //   this.appInsights.trackEvent({name: "Cart.CreateOrder", properties: ev});
      //   this.loader = true
      //   //ev.shippingAddress.phone = ev.payerPhone;  
      //   this.orderResult.email = ev.payerEmail      
      //   // TODO environment variables
      //   let resp = await axios({ url: process.env.VUE_APP_API_URL + "stripe/paymentrequest", 
      //       data: {
      //         shippingAddress: ev.shippingAddress,
      //         shippingOption: ev.shippingOption,
      //         referenceId: this.referenceId,
      //         email: ev.payerEmail
      //       }, 
      //       method: "POST", 
      //       mode: 'no-cors' })
      //   //console.log(resp.data.client_secret);
      //   let clientSecret = resp.data.client_secret;
      //   // Confirm the PaymentIntent without handling potential next actions (yet).
      //   const {paymentIntent, error: confirmError} = await stripe.confirmCardPayment(
      //     clientSecret,
      //     {payment_method: ev.paymentMethod.id},
      //     {handleActions: false}
      //   );

      //   if (confirmError) {
      //     // Report to the browser that the payment failed, prompting it to
      //     // re-show the payment interface, or show an error message and close the payment interface.
      //     this.loader = false
      //     this.$refs.snackbar.show('Stripe: An error occurred with your payment request, please try again or get in touch with us.');
      //     console.error('Stripe', confirmError)
      //     this.appInsights.trackEvent({name: "Cart.Error", properties: confirmError});
      //     ev.complete('fail');
      //   } else {
      //     // Report to the browser that the confirmation was successful, prompting it to close the browser payment method collection interface.
      //     ev.complete('success');
      //     // Check if the PaymentIntent requires any actions and if so let Stripe.js handle the flow. 
      //     // If using an API version older than "2019-02-11" instead check for: `paymentIntent.status === "requires_source_action"`.
      //     if (paymentIntent.status === "requires_action") {
      //       // Let Stripe.js handle the rest of the payment flow.
      //       const {error} = await stripe.confirmCardPayment(clientSecret);
      //       if (error) {
      //         this.loader = false
      //         // The payment failed -- ask your customer for a new payment method.
      //         this.$refs.snackbar.show('Stripe: An error occurred with your payment request, please try again or get in touch with us.');
      //         console.error("Stripe", error)
      //         this.appInsights.trackEvent({name: "Cart.Error", properties: error});
      //       } else {
      //         // The payment has succeeded.
      //         this.stripeCheckoutSuccess(paymentIntent, paymentRequest)
      //       }
      //     } else {
      //       // The payment has succeeded.            
      //       this.stripeCheckoutSuccess(paymentIntent, paymentRequest)
      //     }
      //   }
      // });

      // let stripeShippingOptions = {
      //   hu: {
      //     id: 'delivery-hungary',
      //     label: 'Delivery in Hungary',
      //     detail: 'Delivery in Hungary',
      //     amount: 990,
      //   },
      //   pu: {
      //     id: 'local-pickup',
      //     label: 'PICKUP',
      //     detail: 'Dob street, Budapest - we will get in touch to arrange the day and time.',
      //     amount: 0,
      //   }/*,
      //   eu: {
      //     id: 'delivery-europe',
      //     label: 'Delivery in Europe',
      //     detail: 'Standard delivery in the EU',
      //     amount: 1699,
      //   }*/
      // }

      // let firstFuckingEvent = true
      // paymentRequest.on('shippingaddresschange', async (ev) => {
      //   let stripeShippingCountry = this.shippingCountries.find(c => c.code == ev.shippingAddress.country)
      //   if (!stripeShippingCountry) {
      //     this.appInsights.trackEvent({name: "Cart.ShippingReject"});
      //     ev.updateWith({status: 'invalid_shipping_address'});
      //   } else {
      //     // // Perform server-side request to fetch shipping options
      //     // const response = await fetch('/calculateShipping', {
      //     //   data: JSON.stringify({
      //     //     shippingAddress: ev.shippingAddress
      //     //   })
      //     // });
      //     // const result = await response.json();
      //     // if(stripeShippingCountry.code != 'HU' || this.shippingCountry.code != 'PICKUP')
      //     //   this.setShippingCountry(stripeShippingCountry)
      //     this.appInsights.trackEvent({name: "Cart.ShippingChange", properties: ev.shippingAddress});
          
      //     ev.updateWith({
      //       status: 'success',
      //       total: {
      //         label: this.longDescription,
      //         amount: Math.round( (this.price + (firstFuckingEvent ? this.shippingCountry.price : stripeShippingCountry.price))*100 )//.toFixed(1), // TODO EZT A GECIT IS UPDATELNI KÉNE CONDITIONALLY
      //       },
      //       // The first shipping option in this list appears as the default option in the browser payment interface.
      //       shippingOptions: stripeShippingCountry.code == 'HU' 
      //         ? this.shippingCountry.code == 'PICKUP'  
      //           ? [ stripeShippingOptions.pu, stripeShippingOptions.hu ]                 
      //           : [ stripeShippingOptions.hu, stripeShippingOptions.pu ]
      //         : [ stripeShippingOptions.eu ],
      //     });
      //     firstFuckingEvent = false
      //   }
      // });

      // paymentRequest.on('shippingoptionchange', async (ev) => {        
      //   // call event.updateWith within 30 seconds
      //   // ezt azért kommenteztem ki, mert ha csak cancelezi a gpay-t de előtte átállította mondjuk kezdeti pickupról valami országra a shippinget gpay-ben, akkor a paypal buttont újra kéne initelni
      //   // szóval a confirmation screent meg stb a payment success data-ból kell kideriteni hogy shipping v pickup lett végül
      //   // if(ev.shippingOption.id == stripeShippingOptions.pu.id)
      //   //   this.setShippingCountry(this.shippingCountries[0])
      //   this.appInsights.trackEvent({name: "Cart.ShippingOptionChange", properties: ev.shippingOption});

      //   ev.updateWith({
      //     status: 'success',
      //     total: {
      //       label: this.longDescription,
      //       amount: (this.price*100 + ev.shippingOption.amount)//.toFixed(1),
      //     },
      //   });
      // });


      

      //OverlayScrollbars(document.body).scroll({ el : this.$refs.summary, block : { y : "begin", x : "nearest" }, margin : 0 }, 500);      
      
    },
    remove: function(){
      this.clearCartFrameModel();
      setTimeout(() => this.scalePreviews(), 100);

      this.appInsights.trackEvent({name: "Cart.Remove"});
    },
    configure: function(){
      this.$store.commit('setInCartConfigFlag', true); 
      document.querySelector('.preview').classList.add('hide')
      let measureX = document.querySelector('.preview .pureTn .width')
      let measureY = document.querySelector('.preview .pureTn .height')
      if(measureX)
        measureX.style.width = 0
      if(measureY)
        measureY.style.width = 0
      this.editing = true;
    },
    closeCountrySelector: function(e){
      const withinBoundaries = e.composedPath().includes(this.$refs.countrySelector);
      if(this.countrySelectorOpen && e.keyCode == 27 || (e.keyCode == undefined && !withinBoundaries /*(e.target != this.$refs.countrySelector)*/))
        this.countrySelectorOpen = false;
    },
    ...mapMutations([
      'clearCartFrameModel', // map `this.clearFrameModel()` to `this.$store.commit('clearFrameModel')`
      'setShippingCountry',
      'enableCart'
    ])
  },
  mounted: function(){
    this.enableCart()
    
    window.addEventListener('resize', this.scalePreviews);
    this.scalePreviews();
    window.addEventListener("keyup", this.closeCountrySelector, false);
    window.addEventListener("click", this.closeCountrySelector, false);

    // let externalScript = document.getElementById('paypal-sdk');
    // if(!externalScript){
    //   externalScript = document.createElement('script');
    //   externalScript.id = 'paypal-sdk';
    //   // locale needed because PayPal guest checkout is stupid and always defaults to US region, even if you set shipping country exlpicitly...
    //   //let locale = this.shippingCountry.code != 'PICKUP' ? ('&locale=en_' + this.shippingCountry.code) : '';
    //   //externalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=ATRgrZIox6gV_Rx2jYBNXPn0x13vmegNsO4ZiCuT0sbKvvsjZ8OG7AHpwscmHKurPlswG2bNM-xXsrbP&currency=EUR'/* + locale*/);
    //   //externalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=AU7_4tHDeHxIvdF3cH0eyDLY5qFpn_F9jw-Oke1CAk4yENGeoC6nnTAEiG__n2ZQ6p0jAOEHrczqFNgZ&currency=EUR'/* + locale*/);
    //   //externalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=ASxNeW-_WZH_9v579T1ydoFTAAu-s8FPN8XHyz_JDbh66X7R5VXB3bGUfi7ZkeTsg2b6mc-XDPmN2B0h&currency=EUR'/* + locale*/);
    //   //externalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=ARv25bUWWrWocQT9oBUVrci-rxGsQQc8cUIs06Yo0ZdfGz0Ms1WjCLgR5W53T0ucgIyqZ7WRUsHmxfIb&currency=EUR'/* + locale*/);
    //   externalScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_INTEGRATION_MODE == 'LIVE' ? process.env.VUE_APP_PAYPAL_LIVE_CLIENT_ID : process.env.VUE_APP_PAYPAL_SANDBOX_CLIENT_ID}&currency=EUR`/* + locale*/);
    //   //externalScript.setAttribute('data-sdk-integration-source', 'button-factory');
    //   document.head.appendChild(externalScript);
    //   // externalScript.addEventListener('load', () => {
    //   //   //this.initPayPalButton();
    //   //   paypal.Buttons().render('main');
    //   // });    
    // }

    let externalScript2 = document.getElementById('stripe-sdk');
    if(!externalScript2){
      externalScript2 = document.createElement('script');
      externalScript2.id = 'stripe-sdk';      
      externalScript2.setAttribute('src', 'https://js.stripe.com/v3/');      
      externalScript2.addEventListener('load', () => {
        if(!stripe){
          //eslint-disable-next-line
          stripe = Stripe(process.env.VUE_APP_INTEGRATION_MODE == 'LIVE' ? process.env.VUE_APP_STRIPE_LIVE_CLIENT_ID : process.env.VUE_APP_STRIPE_SANDBOX_CLIENT_ID, {
            apiVersion: "2019-05-16",
            betas: ['shipping_address_element_beta_1']
          });  
          //eslint-disable-next-line
          elements = stripe.elements();
        } 
      })
      document.head.appendChild(externalScript2);                   
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scalePreviews);
    window.removeEventListener('keyup', this.closeCountrySelector);
    window.removeEventListener('click', this.closeCountrySelector);
    if(this.paymentConfirmed)
      this.clearCartFrameModel();
  }
};
</script>

<style lang="scss">

.configurator{
  position: absolute;
  left: 0;
  right: 0;
  top: -20px;
  bottom: 0;
  background-color: var(--color-bg);
  z-index: 300;
}

.cart {
    max-width: 880px;
    margin: 0 auto;
    padding-top: 50px;
    margin-bottom: 100px;    
    overflow: visible;

    @media (min-width: $L) {        
      margin-top: 50px;
    }

    .cartfade-enter,
    .cartfade-leave-to {
      visibility: hidden;      
      opacity: 0;
    }

    .cartfade-enter-active,
    .cartfade-leave-active {
      transition: all 0.3s;
    }

    #payment-request-button{
      margin-bottom: 9px;
    }

    #checkoutcontainer, .checkout-messages{
      //width: 100%;
      max-width: 554px;
      //padding-top: 30px;
      clear: both;
      padding: 0 20px 0 20px;
      margin: 0 auto;
      position: relative;

      .termscheckbox{
        margin: 30px 0 5px 0;

        font-size: 14px;
        a {
          font-family: Averia;
          color: var(--color-content-links);
          &:hover{
            color: $orange;
          }
        }
      }

      h2{
        font-family: Averia;
      }

      .shipping {
        margin-bottom:20px;
        .pretty{
          margin-bottom: 10px;          
          font-size: 14px;                    
        }
      }

      .inputgrid{
        display: flex;
        column-gap: 10px;
      }

      .inputrow{
        //min-height: 70px;
        position: relative;
        //margin-bottom: 10px;  
        background-color: transparent;  
        flex-grow: 1;    

        span.errormessage{
          display: block;
          height: 15px;
          line-height: 18px;
          font-size: 12px;
          color: var(--color-error);
          font-family: Averia, Cambria;
          opacity: 0;

          &.hasError{
            opacity: 1;
            transition: opacity 0.5s;
          }

          // &:after{
          //   content: '';
          //   position: relative;
          //   width: 100%;
          //   top: -21px;
          //   display: block;
          //   border-bottom: 1px dashed white;
          //   //border-bottom: 1px solid $orange;
          //   transform-origin: center;
          //   transition: transform 0.2s ease;
          //   transform: scaleX(0);     
          // }

          // &.text:after{
          //   //top: -26px;
          // }
        }

        label{
          font-family: Averia, Cambria;
          position: absolute;
          color: var(--color-cart-label);
          left: 0;
          //opacity: 0.5;
          //top: -20px;
          font-size: 16px;  
          //opacity: 0.5;
          z-index: 1;
          transform: translateY(21px) scale(1);
          transform-origin: left;

          span{
            max-width: 0;
            display: block;
            float: left;
            overflow: hidden;
            padding-right: 0;
          }
        }
      }

      // chrome autocomplete hack           
      input:-webkit-autofill, 
      input:-webkit-autofill:hover, 
      input:-webkit-autofill:focus, 
      input:-webkit-autofill:active, 
      select:-webkit-autofill,
      select:-webkit-autofill:hover,
      select:-webkit-autofill:focus,
      select:-webkit-autofill:active      
      {    
        background-color: transparent;        
        box-shadow: 0 0 0 40px var(--color-bg) inset !important;
        -webkit-box-shadow: 0 0 0 40px var(--color-bg) inset !important;     
        -webkit-text-fill-color: var(--color-contact-input-text); 

        // -moz-appearance: none;
        // -webkit-appearance: none;
        // appearance: none;  
      }

      input:-webkit-autofill::first-line{
        font-family: 'Courier New', Courier, monospace;  
      }

      select{
        -webkit-appearance: none;
        -moz-appearance : none;
        padding: 31px 0 2px 0;   
        width: 100%;        
        outline: none;
        appearance: none;
        border:none;
        border-bottom: 1px solid var(--color-cart-input-border);
        font-family: 'Courier New', Courier, monospace; 
        cursor: pointer;
        background-color: var(--color-bg);
        color: var(--color-contact-input-text);

        ~ label.floated{
          transform: translateY(12px) scale(0.88);
        }
      }

      .select-icon{
        position: absolute;
        right: 10px;
        top: 31px;
      }

      input, textarea{ 
        width: 100%;
        border: none;
        border-bottom: 1px solid var(--color-cart-input-border); //rgba($color: #a0a0a0, $alpha: 0.5);
        //border-bottom: 1px dashed #a0a0a0;
        font-family: 'Courier New', Courier, monospace;    
        outline: none;
        resize: vertical;
        transition: border-color 0.5s ease;
        padding: 31px 0 2px 0;   
        background-color: transparent;   
        user-select: none;  
        color: var(--color-contact-input-text);

        &::placeholder {
          color: transparent;
          transition: color 0.2s ease;
        }

        &:placeholder-shown ~ label {
          cursor: text;
          color: var(--color-cart-label);
          font-size: 16px;
          transform: translateY(21px) scale(1);
          transform-origin: left;

          span{
            max-width: 40px;
            padding-right: 5px;
          }
        }

        &:focus{
          outline: none;
          border-bottom: 1px solid var(--color-share-input-text);

          &::placeholder {  
            color: var(--color-cart-placeholder);
            transition: color 0.2s ease;
            transition-delay: 0.1s;
          }

          ~ label {
            //top: -20px;
            opacity: 0.8;  
            color: var(--color-cart-label-floating);
            transform: translateY(12px) scale(0.88);
            transform-origin: left;   

            span{
              max-width: 0;
              padding-right: 0;
            }     
          }
        }

        &.notEmpty ~ label{
          transform: translateY(12px) scale(0.88);
        }

        &.hasError{
          color: var(--color-error);
          border-bottom-color: var(--color-error);
          &:focus{
            border-bottom-color: var(--color-error);
          }
          //font-weight: bold;
        }

        // &:focus ~ span.errormessage:after {      
        //     transform: scaleX(1);      
        // }
      }


      .paymentoverlay{
        background-color: var(--color-bg);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 50px;
        z-index: 1000;
        opacity: 0;
        animation: fadein 0.5s;       
        animation-delay: 0.1s; 
        animation-fill-mode: forwards;
      }

      @keyframes fadein {
          from { opacity: 0; }
          to   { opacity: 0.8; }
      }



      @media (min-width: $L) {        
        margin: unset;
        padding: 30px 0 0 0;
      }

      .loader{
        background: url(../assets/images/833-loop.svg) center 30px no-repeat;
        background-color: var(--color-bg);
        position: absolute;
        left: 0px;
        top: 0px;
        bottom: 0px;
        right: 0px;
        z-index: 300;
      }

      &.checkoutInProgress{
        padding-top: 30px;
      }

      .phonenumber-message{
        font-size: 12px;
        text-align: justify;
        margin-top: 20px;
      }

      .thankyou-message{ 
        //font-size: 14px;

        a{
          font-family: Averia;
          cursor: pointer;
          font-size: 16px;
          color: var(--color-content-links);
          &:hover{
            color: $orange;
          }
        }

        .social{
          text-align: center;
          max-width: 500px;  
          margin: 0 auto;
          margin-top: 40px;      
          font-size: 20px;
          padding: 0 30px;

          .hashtag{
            color: #d6d6d6;
            font-size: 14px;
            font-weight: bold;
          }

          span {
            padding: 0 5px;
          }

          a {
            font-family: Averia;
            cursor: pointer;
            font-size: 20px;
            color: var(--color-links);
            &:hover{
              color: $orange;
            }
          }
        }
      }
    }

    .preview{      
      width: 100%;
      max-width: 554px;
      //float: left;
      //max-height: 370px;
      margin: 0 auto;

      @media (min-width: $L) {        
        float: left;
      }

      //transition: opacity 0.3s ease;

      &.hide{
        opacity: 0;        
      }

      .aspect-ratio-box {
        height: 0;
        overflow: hidden;
        //padding-top: 2142px / 3000px * 100%;        
        padding-top: 370px / 554px * 100%;        
        position: relative;
        transition: all 0.6s ease;
      
        // .aspect-ratio-box-inside {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 100%;
        // }        

        .width, .height{
          position: absolute;
          // scaled automatically          
          // top: 280px;
          width: 0; 
          // left: 57px;
          text-align: center;          
          opacity: 0;          
          overflow: hidden;

          &:before{
            content: '';
            width: 100%;
            position: absolute;
            border-top: 1px dashed #b7b7b7;
            top: 8px;
            left: 0;
          }

          span{
            padding: 0 8px;
            position: relative;
            background-color: #f0f0f0;
            color: #787878;
            font-size: 16px;
          }
        }

        .height{
          transform-origin: 0 0;
          transform: rotate(-90deg);
        }
      }

      .whiteTn{
        background: url(../assets/images/cart-white-bg.jpg); 
        background-size: contain;         
      }

      .greenTn{
        background: url(../assets/images/cart-green-bg.jpg);
        background-size: contain;
      }

      .pureTn{
        //background-color: #f0f0f0;
        background: url(../assets/images/cart-pure-bg.jpg);
        background-size: contain;

        .width, .height{
          opacity: 1;
          animation: sizingFadeIn 0.6s ease 0.3s forwards;
          transition: width 1s ease;          
        }

      }

      .thumbnails{
        //margin-top: 20px;
        margin-top: 8px;
        
        @media (min-height: 600px) {
          margin-top: 20px;
        }

        .thumbnail {
          width: 100px;
          height: 67px;          
          background-repeat: no-repeat;          
          float: left;
          margin-right: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid var(--color-bg);  
          position: relative; 
          cursor: pointer;
          opacity: 0.5;
          overflow: hidden;

          &:last-child{
            margin-right: 0;
          }

          @media (max-width: 360px) {            
            width: 95px;
            height: 64px; 
            margin-right: 10px;
            //transform: scale(0.8);
          }

          &.pureTn:hover{
            .sizing:after{
              // width: 45px;
              // height: 45px;
              transform: scale(1.08);
              transition: all 0.3s ease;
            }
          }

          .sizing {
            width: 58px;
            height: 58px;
            overflow: hidden;
            position: absolute;
            z-index: 21;
            bottom: 10px;   
            transform-origin: bottom left;         

            &:before{
              content: '';
              width: 85px;
              height: 85px;
              border-top: 1px solid #e8e8e8;    
              box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);        
              background-color: #f0f0f0;
              position: absolute;
              transform: rotate(45deg);
              left: -50px;
              bottom: -45px;
            }

            &:after{
              position: absolute;
              bottom: 0;
              content: '';
              width: 40px;
              height: 40px;              
              background: url(../assets/images/triangleruler.png) bottom left;
              background-size: contain;
              opacity: 0.5;    
              transform-origin: bottom left; 
              transition: all 0.3s ease;          
            }            
          }
          
          &:before {
            background-color: var(--color-bg);
            content: '';
            display: block;
            height: 10px;
            width: 100px;
            clear: both;
            position: absolute;
            bottom: 0;
          }

          &.selected{
            border-bottom: 1px solid #a0a0a0;
          }

          &:hover{
            opacity: 1;
          }
        }
      }

      .frame {
        display: inline-flex;
        padding: 33px;
        height: 138px;
        min-width: 288px; // 3 letters
        border-width: 33px;
        border-style: ridge;
        border-image: url(../assets/images/black-frame.png) 33;
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.4);
        margin: 0 auto;
        //background: url(../assets/images/grey-mat.png) repeat;
        // TODO do some proper texture, not just color
        background-color: #969696;
        position: absolute;
        z-index: 20;        
        left: 0; 
        top: 0;    
        transform: scale(0);
        //transition: all 0.5s ease;
        transition: all 0.5s ease, border-image 0s;
        // TODO egységes helyre tenni majd a frame css-t, most szanasét van két helyen

        &.modern, &.modernwide{
          border-width: 18px; // fasza ezt lehet igazából szépen animálni ghecc, szóval a vastagsággal nem lesz gond. kép váltás pl classic vs modern nemtom hogy megy          
          border-image: url(../assets/images/modern-frame.png) 14;          
          transition: all 0.3s ease, border-image 0s;

          &.modernwide{
            padding: 63px;            
          }

          &.brown{
            border-image: url(../assets/images/modern-frame-brown.png) 14; 
          }
        }

        &.metal{
          padding: 63px;
          border-width: 7px; 
          border-image: url(../assets/images/modern-frame.png) 14;
          transition: all 0.3s ease, border-image 0s;

          &.brown{
            border-image: url(../assets/images/modern-frame-brown.png) 14; 
          }
        }

        &.mat-grey{
          background-color: #989898;

          .letter{
            border: 1px solid #d3d3d3;            
          }
        }
        &.mat-white{
          background-color: #f0f0f0;

          .letter{
            border: 1px solid white;          
          }
        }
        &.mat-black{
          background-color: #202020;
          
          .letter{
            border: 1px solid #808080;            
          }
        }
        
        .letter {
          width: 90px;
          height: 135px;
          border: 1px solid white;
          margin: 0 2px;
          //background: url(../assets/images/variant-test.jpg) no-repeat;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }

    }

    button.confirmPayment{
      width: 100%;
        height: 45px;
        border: none;
        //background-color: var(--color-button-bg);
        cursor: pointer;
        line-height: 45px;
        border-radius: 5px;
        outline: none;
        //position: absolute;
        font-family: Averia, 'courier new';
        // bottom: 0;
        // left: 0;
        // right: 0;
        // margin-left: 20px;
        // margin-right: 20px;
        margin-top: 15px;
        user-select: none;
        background-color: var(--color-button-bg-hover);
        color: $orange;

        &:hover:not([disabled]){
          background-color: $orange;
          color: white;
        }

        &:active:not([disabled]){
          background-color: $orange;
          color: white;
        }

        &[disabled]{
            opacity: 0.5;
            cursor: unset;
            color: $typogray;
        }
    }

    .summary{
      //float: right;
      text-align: right;
      font-size: 14px;
      clear: both;
      margin: 0 auto;
      padding-right: 20px;
      padding-left: 20px;      
      //padding-top: 10%;
      padding-top: 20px;
      max-width: 554px;        

      @media (min-width: $L) {
        letter-spacing: -1px;
        float: right;
        padding-top: 55px;
        clear: none;
        height: 315px;
        padding-right: 0;
        padding-left: 0;  
        min-width: 270px;
        position: sticky;
        top: 0; 
      }

      button{
        width: 100%;
        height: 45px;
        border: none;
        background-color: var(--color-button-bg);
        cursor: pointer;
        line-height: 45px;
        border-radius: 5px;
        outline: none;
        //position: absolute;
        font-family: Averia, 'courier new';
        // bottom: 0;
        // left: 0;
        // right: 0;
        // margin-left: 20px;
        // margin-right: 20px;
        margin-top: 15px;
        user-select: none;

        &.payment-confirmed,
        &.payment-confirmed:hover,
        &.payment-confirmed:active,
        &.payment-confirmed:not([disabled]), 
        &.payment-confirmed:hover:not([disabled]),
        &.payment-confirmed:active:not([disabled]){
          background: transparent;
          font-size: 20px;
          padding-right: 0;
          cursor: unset;
          color: var(--color-text);

          @media (min-width: $L) {
            text-align: right;
          }
        }

        @media (min-height: 600px) {
          margin-top: 20px;
        }

        @media (min-width: $L) {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin-top: 0;

          &.payment-confirmed {
            text-align: right;
          }
        }

        &:hover:not([disabled]){
          background-color: var(--color-button-bg-hover);
          color: $orange;
        }

        &:active:not([disabled]){
          background-color: $orange;
          color: white;
        }

        &[disabled]{
            opacity: 0.5;
            cursor: unset;
            color: $typogray;
        }
      }

      .buttons{
        font-family: Averia;  
        color: #c0c0c0;
        min-height: 20px;
        font-size: 18px;
        user-select: none;

        a {          
          cursor: pointer;

          &.emptyCartFontSize{
            font-size: 24px;
          }
        }
        a:not(:hover){
          color: #c0c0c0;
        }
      }

      .breakdown{
        line-height: 18px;
        color: var(--color-content-text);
        //letter-spacing: -0.5px;
        //padding-top: 10%;
        padding-top: 5%;
        position: relative;

        @media (min-height: 600px) {
          line-height: 25px;
        }
        @media (min-height: 670px) {
          line-height: 35px;
        }

        @media (max-width: 360px) {
          letter-spacing: -1px;
        }

        @media (min-width: $L) {
          padding-top: 30px;
          max-width: 270px;
        }

        .countries{
          position: absolute;
          max-height: 200px;
          overflow-y: auto;
          background-color: var(--color-cart-countries-bg);
          right: 40px;
          padding: 10px;
          box-shadow: var(--shadow-cart-countries);
          z-index: 20;

          > div{
            //font-size: 16px;
            line-height: 24px;
            cursor: pointer;
            padding: 0 5px;
            text-align: right;
            text-align: center;
            border-bottom: 1px dashed var(--color-cart-shipto-border);

            &:last-child{
              border: none;
            }

            &:hover{
              background-color: var(--color-cart-countries-hover-bg);
            }
          }
        }

        .shipTo{
          text-decoration: underline;
          padding: 3px 5px;
          border: 1px dashed var(--color-bg);
          //border: 1px dashed #ddd;
          border-radius: 5px;
          //color: $typogray;
          cursor: pointer;

          &:hover{
            border: 1px dashed var(--color-cart-shipto-border);
            border-radius: 5px;
            //color: $typogray;
          }

          .triangleUp{
            opacity: 0.6;
          }

          &.disabled{
            text-decoration: none;

            span{
              opacity: 0.2;
            }
          }

          // span {
          //   //color: $typogray;
          //   font-size: 12px;
          // }
        }

        .price{
          display: inline-block;
          min-width: 35px;
        }

        hr{
          margin-top: 10px;
          height: 1px;
          //background-color: #d9d9d9;
          background-color: var(--color-cart-shipto-border);
          border: none;

          @media (min-height: 670px) {
            margin-top: 20px;
          }
        }

        .total{
          font-size: 18px;
        }
      }
    }

    .infotext{
      max-width: 554px;      
      margin: 0 auto;
      margin-top: 30px;
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      padding: 0 20px;

      @media (min-width: $L) {
        margin: 20px 0 0 0;
        text-align: left;
      }

      a{
        font-family: Averia;
        cursor: pointer;
        font-size: 18px;
        color: var(--color-content-links);

        &:hover{
          color: $orange;
        }
      }
    }      
}

.dark .cart {
  #checkoutcontainer .paymentoverlay{
    background-color: var(--color-bg);
    opacity: 0.8;
  }

  .preview {
    .brightness-adjustment{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(39, 39, 39, 0.2);
    }
    .thumbnails .thumbnail:hover{
      opacity: 0.85;
    }
    .height, .width{
      span{
        color: black;
      }
      &:before{
        border-top: 1px dashed #ababab;
      }
    }
  }
}

@keyframes sizingFadeIn {  
  0% {
    opacity: 0;
  }
  // 25% {
  //   opacity: 0;
  // }
  100% {
    opacity: 1;
  }
}

</style>
